import { IAppState } from '../../common/state';

export function selectNewbuildingBlackFridayTopBannerImage(state: IAppState) {
  return state.featureToggle.newbuildingBlackFridaySettings.topBannerImage ?? '';
}
